import React from 'react'
import { pathRoutes, appModule } from './module'

const userPermissions = new Set<string>()

export function setUserPermission(permissions: AppPermissions) {
  appModule.set(permissions.systemList || [])
  userPermissions.clear()
  let actionCodes = permissions.actionList || []
  for (let actionCode of actionCodes) {
    userPermissions.add(actionCode)
  }
}

export function hasPermission(actionCode: string): boolean {
  // console.log('userPermissions', userPermissions, actionCode)
  if (actionCode) return userPermissions.has(actionCode)

  return true
}
export function getUserPermission(): Set<string> {
  return userPermissions
}

export function getUserRoute() {
  return [...pathRoutes.values()]
}
export const withPermission = (WrappedComponent: React.ComponentType) =>
  class extends React.Component<{ actionCode?: string }> {
    render() {
      const { actionCode } = this.props
      let isShow = !actionCode || hasPermission(actionCode)
      return isShow && <WrappedComponent {...this.props} />
    }
  }




// WEBPACK FOOTER //
// ./src/services/permission.tsx